export default function TriggersEmpty(props) {
  return (
    <div className="flex min-h-96 items-center justify-center">
      <p className="text-md font-base">Triggers Empty</p>
    </div>
  );
}
